'use client';

import React, { Suspense } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { ContactSupport } from '@/app/components/support/ContactSupport';

function ContactSupportContent() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const role = searchParams.get('role');
  const isDemo = searchParams.get('demo') === 'true' || searchParams.get('mock') === 'true';
  const source = searchParams.get('source');
  const demoParam = isDemo ? '&demo=true' : '';

  const handleBack = () => {
    if (role || isDemo) {
      router.push(`/dashboard?role=${role || 'admin'}${demoParam}`);
    } else {
      router.push('/');
    }
  };

  const handleBrowseFAQs = () => {
    const roleQuery = role ? `?role=${role}` : '';
    const demoQueryParam = isDemo ? (roleQuery ? '&demo=true' : '?demo=true') : '';
    router.push(`/support/faqs${roleQuery}${demoQueryParam}`);
  };

  const tabParam = searchParams.get('tab') || searchParams.get('view');
  const initialTab = tabParam === 'tickets' ? 'tickets' : undefined;

  return (
    <ContactSupport
      onBack={handleBack}
      onBrowseFAQs={handleBrowseFAQs}
      initialSource={source || undefined}
      initialTab={initialTab}
    />
  );
}

export default function ContactSupportPage() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center dark:bg-slate-900 dark:text-white">
          Loading Contact Support...
        </div>
      }
    >
      <ContactSupportContent />
    </Suspense>
  );
}
